import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { UIErrorHandler } from '../../core/uiErrorHandler';

@Component({
  selector: 'app-invoice-numbering',
  templateUrl: './invoice-numbering.component.html',
  standalone: false,
})
export class InvoiceNumberingComponent {
  invoiceNumber: number = 0;
  initialInvoiceNumber: number = 0;

  constructor(
    public dialogRef: MatDialogRef<InvoiceNumberingComponent>,
    private uiErrorHandler: UIErrorHandler,
  ) {}

  save() {
    if (this.invoiceNumber < this.initialInvoiceNumber) {
      this.uiErrorHandler.handleError(
        new Error(
          'That invoice number has already been used. Please enter a higher number.',
        ),
      );
      this.invoiceNumber = this.initialInvoiceNumber;
      return;
    }

    this.dialogRef.close(this.invoiceNumber);
  }
}
